export default __webpack_public_path__ + "static/media/icon-curbside-pickup.053f0bd5.svg";